<!-- 出入库记录 -->
<template>
  <div style="display: inline;">
    <el-descriptions ref="desc" size="mini" :inline="true" :colon="false" :model="yt.conditions" class="demo-form-inline">
      <el-descriptions-item :label="$t('mujubianhao')">
        {{ $attrs.mouldEquipment.no }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('mujubianma')">
        {{ $attrs.mouldEquipment.code }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('mujumingcheng')">
        {{ $attrs.mouldEquipment.name }}
      </el-descriptions-item>
    </el-descriptions>
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/in/out/record/page" getKey="rows" :columns="columns">
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  components: {},
  name: "web_mould_in_out_record",
  data() {
    return {
      inBillTypeJson: this.$store.state.dictJson.MOULD_IN_WAREHOUSING_TYPE,
      outBoundTypeJson: this.$store.state.dictJson.MOULD_OUTBOUND_TYPE,
      columns: [
        {
          label: "churukuleixing",
          prop: "type",
          type: 'tag',
          tags: {
            1: {
              color: '#11beea',
              text: this.$t('ruku')
            },
            2: {
              color: '#6fe038',
              text: this.$t('chuku')
            },
          },
          width: 100,
        },
        {
          label: "xifenleixing",//细分类型
          prop: "childType",
          width: 130,
          formatter: (row, column, cellValue) => {
            return this.getChildTypeDisplayValue(row.row.type, row.row.childType);
          },
        },
        {
          label: "caozuoshijian",
          prop: "createTime",
          type: "time",
          width: 180,
        },
        {
          label: "caozuoren",
          prop: "createByObject.nickname",
          width: 180,
        },
        {
          label: "cangkubianma",
          prop: "warehouse.code",
        },
        {
          label: "cangkumingcheng",
          prop: "warehouse.name",
        },
        {
          label: "kuqubianma",
          prop: "warehouseArea.code",
        },
        {
          label: "kuqumingcheng",
          prop: "warehouseArea.name",
        },
        {
          label: "kuweibianma",
          prop: "warehouseLocation.code",
        },
        {
          label: "kuweimingcheng",
          prop: "warehouseLocation.name",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        mouldId: this.$attrs.mouldEquipment.id,
        pageSize: 10,
        orderBy: "createTime desc",
      };
      this.yt.get(1);
    }, 300);
  },
  filters: {
    getEquipmentName(value) {
      return value
        .map((item) => {
          return item.name;
        })
        .join(",");
    },
  },
  methods: {
    getChildTypeDisplayValue(type, childType) {
      if (type === '1') {
        // 从 inBillTypeJson 中查找对应的值
        const found = this.inBillTypeJson[childType];
        return found ? this.$t(found) : childType; // 如果找到则返回 label，否则返回原始值
      } else if (type === '2') {
        // 从 outBoundTypeJson 中查找对应的值
        const found = this.outBoundTypeJson[childType];
        return found ? this.$t(found) : childType; // 如果找到则返回 label，否则返回原始值
      } else {
        return childType; // 默认返回原始值
      }
    },
  },
};
</script>

<style scoped lang="scss">
.shift {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
